module.exports = __webpack_public_path__ + "static/media/sologo.20cf98ad.png";